export default __webpack_public_path__ + "static/Dallas-99de332c5ca2ff6d0d3df9ec41ad42d6.webp";